<template>
    <section id = "aboutUs" >
       <dl>
           <dt>1、什么是代金券？</dt>
           <dd>代金券是优托邦发行和认可的购物券，可以在优托邦手机客户端消费付款时抵扣相应面值的金额。</dd>
           <dt>2、如何获取代金券？</dt>
           <dd>优托邦客户端会不定期推出活动，手机用户可以经常关注手机客户端弹出的活动通知以及各类推广活动获取代金券。</dd>
           <dt>3、如何使用代金券？</dt>
           <dd>在优托邦手机客户端付款时，可以选择使用代金券并抵扣相应代金券金额。</dd>
           <dt>4、代金券找零兑现吗？</dt>
           <dd>代金券不找零、不兑现。</dd>
       </dl>
    </section>
</template>

<script>
    export default {
        created() {
            document.title = '代金券使用规则';
        }
    }
</script>

<style  lang="scss">
    @import '../../assets/css/px2rem.scss';
    #aboutUs{
        padding:px2rem(20);
        font-size: px2rem(14);
        line-height: px2rem(20);
        color: #666;
        letter-spacing: 0.5px;
        text-align: justify;
        dt{
            color: #333;
            font-size: px2rem(16);
            line-height: px2rem(40);
            font-weight: bold;
        }
        dd{
            margin-bottom: px2rem(20);
        }
    }
</style>